module.exports = __webpack_public_path__ + "img/Icon_Tax_Active.932c60e5.png";